import { isAnObject } from '../../../../../components/Form/validations';
import SearchBarSingle from '../../../../../components/SearchBarV3/SearchBarSingle';
import JobDateRangePicker from '../../../components/CustomComponents/JobDateRangePicker';
import { getStartFieldError } from '../../../helpers';
import {
  getEndDateFieldErrorMax60Days,
  isValidDateRangeMax60Days,
} from '../../utils/recurringTwoWeeksHelpers';

export const corporationField = (value) => ({
  ComponentType: SearchBarSingle,
  preDefinedOptions: [],
  data: null,
  key: 'id',
  name: 'corporation',
  testId: 'corporation',
  required: true,
  variant: 'standard',
  optionLabel: 'name',
  placeholder: 'Corporation',
  fullWidth: true,
  onSubmitApiCallData: {
    httpMethod: 'POST',
    route: 'corporations/read',
  },
  optionDisplayField: 'name',
  validate: isAnObject(value),
});

export const positionTemplateField = ({ corporationId, value }) => ({
  ComponentType: SearchBarSingle,
  preDefinedOptions: [],
  data: {
    filters: [
      {
        field: 'corporation._id',
        value: corporationId,
        operation: 'equalsID',
      },
      {
        field: 'approved',
        value: true,
        operation: 'equals',
      },
    ],
  },
  name: 'positionTemplate',
  testId: 'positionTemplate',
  required: true,
  variant: 'standard',
  optionLabel: 'name',
  placeholder: 'Position',
  fullWidth: true,
  onSubmitApiCallData: {
    httpMethod: 'POST',
    route: 'position-templates/read',
  },
  optionDisplayField: 'name',
  disabled: !corporationId,
  validate: isAnObject(value),
});

export const locationField = ({ positionTemplate, value }) => {
  const locations = positionTemplate?.locations?.map((location) => ({
    address: location.address,
    _id: location._id,
    description: location.description,
  }));

  return {
    ComponentType: SearchBarSingle,
    dropDownOptions: locations || [],
    data: null,
    name: 'location',
    testId: 'location',
    required: true,
    variant: 'standard',
    optionLabel: 'name',
    placeholder: 'Location',
    fullWidth: true,
    optionDisplayField: 'description',
    disabled: !positionTemplate,
    validate: isAnObject(value),
  };
};

export const departmentField = ({ positionTemplate, value }) => ({
  ComponentType: SearchBarSingle,
  dropDownOptions: positionTemplate?.departments || [],
  data: null,
  name: 'department',
  testId: 'department',
  required: true,
  variant: 'standard',
  optionLabel: 'name',
  placeholder: 'Department',
  fullWidth: true,
  optionDisplayField: 'name',
  disabled: !positionTemplate,
  validate: isAnObject(value),
});

export const dateRangeField = () => ({
  ComponentType: JobDateRangePicker,
  key: 'dateRange',
  name: 'dateRange',
  testId: 'dateRange',
  validate: isValidDateRangeMax60Days,
  maxDaysAfterStart: 60,
  getStartError: getStartFieldError,
  getEndError: getEndDateFieldErrorMax60Days,
});
